'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
    $scope.global = Global;

    let model = this;
    model.settings = settings;
    model.tableIdentifiers = {
        key: false,
        id: false
    };

    socketIo('/api/ioc_notifications/ad_events_drill').then(function(socket) {
        /////////////
        /// TABLE ///
        /////////////
        // register data object
        $scope.main.registerVisual({
                // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
                refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'table',
                    socket: socket
                },
                grouping: ['id'],
                sort: {
                    direction: '-', // '-' == desc, '+' == asc
                    col: 'time'
                },
                title: 'Active Defense Events Full',
                columns: [{
                    title: 'Last Seen',
                    select: 'time',
                    dView: true
                }, {
                    title: 'Local IP',
                    select: 'local_ip',
                    dView: true
                }, {
                    title: 'Local Zone',
                    select: 'local_zone',
                    dView: true
                }, {
                    title: 'Local Stealth',
                    select: 'local_stealth',
                    dView: true
                }, {
                    title: 'Local Machine',
                    select: 'local_hostname',
                    dView: true
                }, {
                    title: 'Local User',
                    select: 'local_user',
                    dView: true
                }, {
                    title: 'Local Port',
                    select: 'local_port',
                    dView: true
                }, {
                    title: 'Remote IP',
                    select: 'remote_ip',
                    dView: true
                }, {
                    title: 'Remote Stealth',
                    select: 'remote_stealth',
                    dView: true
                }, {
                    title: 'Remote Machine',
                    select: 'remote_machine',
                    dView: true
                }, {
                    title: 'Remote User',
                    select: 'remote_user',
                    dView: true
                }, {
                    title: 'Remote Port',
                    select: 'remote_port',
                    dView: true
                }, {
                    title: 'Type',
                    select: 'ad_type',
                    dView: true
                }, {
                    title: 'Rule',
                    select: 'ad_rule',
                    dView: true
                }, {
                    title: 'Details',
                    select: 'ad_detail',
                    dView: true
                }, {
                    title: 'ID',
                    select: 'ad_id',
                    dView: true
                }, {
                    title: 'Level',
                    select: 'ad_level',
                    dView: true
                }, ],
                searchCategories: {
                    'local_stealth': 'Local Stealth',
                    'local_hostname': 'Local Hostname',
                    'local_user': 'Local User',
                    'local_ip': 'Local IP',
                    'local_zone': 'Local Zone',
                    'local_port': 'Local Port',
                    'remote_stealth': 'Remote Stealth',
                    'remote_machine': 'Remote Hostname',
                    'remote_user': 'Remote User',
                    'remote_ip': 'Remote IP',
                    'remote_zone': 'Remote Zone',
                    'remote_port': 'Remote Port',
                    'ad_type': 'Type',
                    'ad_rule': 'Rule',
                    'ad_detail': 'Details',
                    'ad_id': 'ID',
                    'ad_level': 'Level',
                }
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.tableIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // initalize table with column information so it can compile the directive
                $scope.$broadcast('table-build', model.tableIdentifiers);

                let time = angular.copy($scope.main.getTime());
                model.loadStart = time.end
                model.loadEnd = time.end
                    // return promise to build dimensions and groups for table
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            .then(function(result) {
                model.complete = true;
                // stop the table spinner as soon as the resolve comes in
                usSpinnerService.stop(model.tableIdentifiers.id);
            }, function(err) {

            }, function(result) {
                // add rows
                $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                    // with our first data return, we can build dimensions and groups for our data
                    $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function() {
                        // dont start the spinner if the table loads faster than building group dim
                        if (!model.complete) {
                            // start table spinner right before init, but after build
                            usSpinnerService.spin(model.tableIdentifiers.id);
                        }
                        // initalize rows
                        $scope.$broadcast('init', model.tableIdentifiers);
                        if (result.min) {
                            model.loadStart = result.min;
                        }
                    }, function(err) {
                        console.log('error')
                        console.log(err)
                    })
                } else {
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                    $scope.$broadcast('updatedData', model.tableIdentifiers.id);
                }
            })
        $scope.$on('$destroy', function() {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/ioc_notifications/ad_events_drill.js
 **/